import { ReactElement, useCallback, useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import GratiPageWrapper from '../components/common/GratiPageWrapper';
import CompetitionEditor from '../components/competition/CompetitionEditor';
import { ActionProps, useApp } from '../contextProviders/AppProvider';
import { useAuth } from '../contextProviders/AuthProvider';
import useCompetition from '../dataHooks/useCompetition';
import { useCompetitionMutators } from '../dataMutators/useCompetitionMutators';
import Competition from '../types/Competition';

export default function CompetitionEditPage(): ReactElement {
  const { competitionId } = useParams();
  const navigate = useNavigate();
  const { setPageName } = useApp();
  const { isGod } = useAuth();
  const { competition, isCompetitionLoading, competitionError } = useCompetition(competitionId);
  const { updateCompetition, deleteCompetition } = useCompetitionMutators();

  const [pageActions, setPageActions] = useState<ActionProps[] | null>(null);
  const [godActions, setGodActions] = useState<ReactElement | null>(null);

  useEffect(() => {
    if (competition?.name) {
      setPageName(competition.name);
    } else {
      setPageName('Edit Competition');
    }
  }, [competition, setPageName]);

  const handleDelete = useCallback((toDelete: Competition) => {
    deleteCompetition(toDelete).then(() => navigate(-1));
  }, [deleteCompetition, navigate]);

  const handleActionsChange = useCallback((actions: ActionProps[] | null, godActionsArg: ReactElement | null) => {
    setPageActions(actions);
    setGodActions(godActionsArg);
  }, []);

  return (
    <GratiPageWrapper
      validateUser={() => isGod}
      isContentLoading={isCompetitionLoading && !competition}
      contentError={competitionError}
      pageActions={pageActions}
      godActions={godActions}
    >
      {competition && (
        <CompetitionEditor
          competition={competition}
          updateCompetition={updateCompetition}
          handleDelete={handleDelete}
          onActionsChange={handleActionsChange}
        />
      )}
    </GratiPageWrapper>
  );
}
